import React from 'react';

import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import Icon from '@mdi/react'
import {mdiClose} from '@mdi/js'

import './index.scss';
import { inject } from 'mobx-react';

@inject('translate')
export default class Search extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            value:this.props.value || '',
            data: [],
            anchorEl: null,
        }
    }

    componentWillMount() {
        if(this.props.data) {
            document.addEventListener('click', this.handleClickedOutside)
        }
    }

    handleClickedOutside  = (evt) => {
        this.setState({anchorEl: false})
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        
        if (!this.props.data) {
            return;
        }
        
        this.title = "";
        
        if (Object.keys(this.props.data).length > 0 && prevState.anchorEl === false)
        {
                this.setState({
                    anchorEl: true
                });
        }
    
        if (Object.keys(this.props.data).length === 0 && prevState.anchorEl === true) {
            this.setState({
                anchorEl: false
            });
        }
    }
    
    // componentWillReceiveProps () {
    //     if(this.props.data && this.state.value !== "") {
    //         this.setState({
    //             data: this.props.data,
    //             anchorEl: true
    //         })
    //     }
    //     else {
    //         this.setState({
    //             data: [],
    //             anchorEl: false
    //         })
    //     }
    // }

    

    handleOnChange = event => {
        this.props.onChange(event.target.value);
        this.setState({
            value:event.target.value
        })
    }

    handleClearInputField = () => {
        this.setState({value: ""})
        this.props.onChange("")
    }
    title = "";

    render() {
        
        const { data } = this.props;
        
        return (
            <div className={'search-box ' + this.props.classes}>
                <SearchIcon/>
                <InputBase
                        value={this.state.value}
                        placeholder={this.props.placeholder}
                        className={'search-input '}
                        onChange={this.handleOnChange}
                        endAdornment={this.state.value === '' ? null : <div onClick={this.handleClearInputField} className={'clear-input'}><Icon path={mdiClose} size={1}/></div>}
                    />
                    {data && Object.keys(data).length && this.state.anchorEl
                        ?
                        <div className={'global-search'} >
                            {Object.keys(data).map(category => data[category].map(suggestion => {
                                
                                let finalUrl;
                                if(category === 'administrators') {
                                    finalUrl = suggestion.url.split("/v1")[1] + "/edit/tab=0"
                                }
                                else if(category === 'orders') {
                                    finalUrl = suggestion.url.split("/v1")[1]
                                }
                                else if(category === 'clients') {
                                    finalUrl = suggestion.url.split("/v1")[1] + "/basic"
                                }
                                else if(category === 'products') {
                                    finalUrl = suggestion.url.split("/v1")[1] + "/detail"
                                }
                                
                                if(this.title !== category) {
                                    this.title = category
                                    if(category === "clients") {
                                        return <div key={this.title} className={'category-type'}>
                                                    <p>{this.props.translate.i18n.GLOBAL.MENU.CLIENTS}</p>
                                                    <a href={finalUrl} key={suggestion.id} >
                                                        <div className={'found-item'} >
                                                            <p >{suggestion.title}</p>
                                                            <span>{suggestion.description}</span>
                                                        </div>
                                                    </a>
                                                </div>
                                    }
                                    else if (category === "products") {
                                        return <div className={'category-type'} key={this.title} >
                                                    <p>{this.props.translate.i18n.GLOBAL.MENU.PRODUCTS}</p>
                                                    <a href={finalUrl} key={suggestion.id} >
                                                        <div className={'found-item'} >
                                                            <p >{suggestion.title}</p>
                                                            <span>{suggestion.description}</span>
                                                        </div>
                                                    </a>
                                                </div>
                                    }
                                    else if (category === "orders") {
                                        return <div className={'category-type'} key={this.title} >
                                                    <p>{this.props.translate.i18n.GLOBAL.MENU.ORDERS}</p>
                                                    <a href={finalUrl} key={suggestion.id} >
                                                        <div className={'found-item'} >
                                                            <p >{suggestion.title}</p>
                                                            <span>{suggestion.description}</span>
                                                        </div>
                                                    </a>
                                                </div>
                                    }
                                    else {
                                        return <div className={'category-type'} key={this.title} >
                                                    <p>{this.props.translate.i18n.GLOBAL.MENU.ADMINISTRATORS}</p>
                                                    <a href={finalUrl} key={suggestion.id} >
                                                        <div className={'found-item'} >
                                                            <p >{suggestion.title}</p>
                                                            <span>{suggestion.description}</span>
                                                        </div>
                                                    </a>
                                                </div>
                                    
                                    }
                                    
                                }
                                return (
                                    <a href={finalUrl} key={suggestion.id} >
                                        <div className={'found-item'} >
                                            <p>{suggestion.title}</p>
                                            <span>{suggestion.description}</span>
                                        </div>
                                    </a>
                                );
                            }))}
                        </div>
                        :
                        null
                    }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/basic/search/index.js